<template>

	<div class="row">
		<div class="col-6 wrap-list">
			<h3>{{title1}}</h3>
			<draggable
			class="dragArea list-group"
			:list="products"
			:clone="clone"
			:group="{ name: 'products', pull: pullFunction }"
			@start="start"
			>
			<div
			class="nestable-item"
			v-for="element in products"
			:key="element.id"
			>
			{{ element.title }}
		</div>
	</draggable>
</div>

<div class="col-6 wrap-list">
	<h3>{{title2}}</h3>
	<input type="text" placeholder="Търсяне продукти" v-model="search" @keyup="searchItems">
	<draggable
	class="dragArea list-group"
	:list="items"
	group="products"
	>
	<div
	class="nestable-item"
	v-for="element in items"
	:key="element.id"
	>
	{{ element.title }}
</div>
</draggable>
</div>


</div>




</template>


<script>
	import axios from 'axios'

	import draggable from "vuedraggable";
    
    import sortable from '../../mixins/sortable'
    // import database from '../../mixins/database'



	export default {
		name: 'sortable-products',
        mixins: [ sortable],

		props: {
			products: {
				type: Array,
				default: [],
			},
			select: {
				type: String,
				required: true,
			},
			title1: {
				type: String,
				default: 'Избрано',
			},
			title2: {
				type: String,
				default: 'Доступно'
			}
		},
		components: {
			draggable,

		},
		
		data() {
			return {
				//itemsName: 'product',
			

			}
		},
		created() {
			console.log(this.items)
		},

		watch: {
			items() {
				console.log(this.products)
				this.$emit('exportProducts', this.products)
			},
			
		},
		
		
	}
</script>

<style scoped>
.list-group {
	    height: 350px;
    overflow: auto;
}
.nestable-item {
	cursor: pointer;
	padding: 5px;
	width: 300px;
	background: #fff;
	border: 1px dotted #ccc;
	border-radius: 4px;
	font-size: 13px;
	color: #6c757d;
	margin-bottom: 10px;
}
.wrap-list input {
	color: #6c757d;
	font-size: 12px;
	display: block;
	width: 100%;
	font-size: 13px;
	height: 34px;
	line-height: 10px;
	border-width: 1px 0px;
	border-top: 1px solid transparent;
	border-bottom: 1px solid rgb(226, 226, 226);
	outline: none;
	margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/app_modules/SortableProducts.vue